import { dataQualityCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQualityCircleSolid = /*#__PURE__*/createIcon(dataQualityCircleSolid)
export default IconQualityCircleSolid
